/***
 *
 *   CONTACT FORM
 *   Marketing site contact form (Phase 10 owns the public page chrome).
 *   Token-pass only in Phase 7 — keep Gravity Form, use Message success state.
 *
 *   PROPS
 *   teamSize: append a team-size select (optional, used by the landing CTA)
 *   labels: override the default field labels (optional)
 *   placeholders: field placeholders (optional)
 *   buttonText: submit button label (optional)
 *
 **********/

import { Fragment, useState } from 'react';
import { Form, Message } from 'components/lib';
import { useTranslate } from 'app/translations';

const TEAM_SIZES = ['1-5', '6-20', '21-100', '100+'];

export function ContactForm(props) {
    const { _t } = useTranslate();
    const [sent, setSent] = useState(false);

    const labels = props.labels || {};
    const placeholders = props.placeholders || {};

    const fields = {
        name: {
            label: labels.name || _t('name.yourName'),
            placeholder: placeholders.name,
            type: 'text',
            required: true,
            errorMessage: _t('name.empty'),
        },
        email: {
            label: labels.email || _t('email.yourEmail'),
            placeholder: placeholders.email,
            type: 'email',
            required: true,
            errorMessage: _t('email.empty'),
        },
        ...(props.teamSize && {
            team_size: {
                label: labels.teamSize || _t('landing.cta.form.teamSize'),
                type: 'select',
                default: TEAM_SIZES[0],
                options: TEAM_SIZES.map((size) => ({ value: size, label: size })),
            },
        }),
        message: {
            label: labels.message || _t('formMessage.title'),
            placeholder: placeholders.message,
            type: 'textarea',
            required: true,
            errorMessage: _t('formMessage.empty'),
        },
    };

    if (sent) {
        return <Message title={_t('message.sent')} type="success" text={_t('message.thanks')} />;
    }

    return (
        <Fragment>
            <Form
                data={fields}
                method="POST"
                url="/api/utility/mail"
                callback={() => setSent(true)}
                buttonText={props.buttonText || _t('formMessage.send')}
            />
        </Fragment>
    );
}
